import { render, staticRenderFns } from "./SwiperPaginator.vue?vue&type=template&id=f818b186&functional=true&"
import script from "./SwiperPaginator.vue?vue&type=script&lang=js&"
export * from "./SwiperPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports